document.addEventListener('DOMContentLoaded', () => {
    const arrowRight = document.querySelector('.header-arrow-container.arrow-right');
    const arrowLeft = document.querySelector('.header-arrow-container.arrow-left');
    const menuList = document.querySelector('.tiles-menu');

    function checkScroll() {
        const maxScrollLeft = menuList.scrollWidth - menuList.clientWidth;

        if (menuList.scrollLeft <= 0) {
            arrowLeft.style.visibility = 'hidden';
        } else {
            arrowLeft.style.visibility = 'visible';
        }

        if (menuList.scrollLeft >= maxScrollLeft) {
            arrowRight.style.visibility = 'hidden';
        } else {
            arrowRight.style.visibility = 'visible';
        }
    }

    setTimeout(checkScroll, 1000);

    menuList.addEventListener('scroll', checkScroll);

    arrowRight.addEventListener('click', () => {
        menuList.scrollBy({
            left: 200,
            behavior: 'smooth'
        });

        setTimeout(checkScroll, 300);
    });

    arrowLeft.addEventListener('click', () => {
        menuList.scrollBy({
            left: -200,
            behavior: 'smooth'
        });

        setTimeout(checkScroll, 300);
    });

    window.addEventListener('resize', checkScroll);
});
